import React, { useContext } from "react";
import dynamic from "next/dynamic";
// import { AnimatePresence } from "framer-motion";
import NoSSRAnimatePresence from "components/NoSSRAnimatePresence";

// import NextLink from "next/link";
import ConditionalWrapper from "@components/Reusables/ConditionalWrapper";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import FadeInOut from "@components/Animations/FadeInOut";
import { Logo, LogoSmall } from "components/Logo";
import { CartIcon } from "components/CartComponents";
import ScheduleAdvisingSession from "components/CTA/ScheduleAdvisingSession";
import JoinMembership from "components/CTA/JoinMembership";
import RenewMembership from "components/CTA/RenewMembership";
import { UserContext, NavContext } from "contexts/";

import useMembershipStatus from "hooks/useMembershipStatus";

import DesktopNavigation from "./Navigation/DesktopNavigation";
// const DynamicDesktopNavigation = dynamic(() => import("./Navigation/DesktopNavigation"), {
// 	loading: () => <header />,
// });
const UserDropdown = dynamic(() => import("./UserDropdown"), {
	loading: () => <header />,
});

export default function DesktopHeader(props = {}) {
	const { slimNav, hasSubNav, hasRegistrationNav } = props;
	const { userData } = useContext(UserContext);
	const { megaNavName, userDropdownOpen } = useContext(NavContext);

	const membershipStatus = useMembershipStatus();

	const { requiresWebsiteBanner, membershipExpireingMessage } = membershipStatus;

	const SubNav = hasSubNav ? hasSubNav : false;

	return (
		<header className={`d-none d-lg-block animate-all  ${slimNav ? " my-0" : "my-3"} `}>
			{/*Nav Row */}
			{!hasRegistrationNav && (
				<ConditionalWrapper
					condition={hasSubNav}
					wrapper={(children) => (
						<FadeInOut
							initial={slimNav ? "hidden" : "visible"}
							animate={slimNav ? "hidden" : "visible"}
							myKey={"hasSubNav"}
							// withHeight={false}
						>
							{children}
						</FadeInOut>
					)}
				>
					<div
						className={`main-nav animate-all row align-items-center g-0  ${
							slimNav && hasSubNav ? "py-0" : "py-1"
						} `}
					>
						{/* Logo col */}
						<Col className="animate-all overflowHidden" lg={slimNav ? 1 : 2} xl={slimNav ? 1 : 2}>
							<NoSSRAnimatePresence>
								{!slimNav && (
									<FadeInOut
										initial={!slimNav ? "hidden" : "visible"}
										animate={slimNav ? "hidden" : "visible"}
										myKey={"largeLogo"}
										withHeight={false}
									>
										{/* <Logo /> */}
										<LogoSmall />
									</FadeInOut>
								)}
								{slimNav && (
									<FadeInOut
										initial={slimNav ? "hidden" : "visible"}
										animate={!slimNav ? "hidden" : "visible"}
										myKey={"smallLogo"}
										withHeight={false}
									>
										<LogoSmall />
									</FadeInOut>
								)}
							</NoSSRAnimatePresence>
						</Col>
						{/* Nav Links */}
						<Col className="" lg={slimNav ? "11" : 10} xl={slimNav ? "11" : { offset: 1, span: 9 }}>
							<FadeInOut
								initial="visible"
								animate={slimNav ? "hidden" : "visible"}
								myKey={"UserDropdown"}
							>
								<div
									className={`row animate-all align-items-end flex-row  justify-content-end gx-2 ${
										slimNav ? "px-0" : "px-1"
									} `}
								>
									<Col xs="auto">
										<UserDropdown />
									</Col>

									<Col className="d-flex align-items-center " xs={"auto"}>
										{requiresWebsiteBanner ? (
											<RenewMembership />
										) : !userData || !userData?.isMember ? (
											<JoinMembership />
										) : (
											userData?.isMember && !requiresWebsiteBanner && <ScheduleAdvisingSession />
										)}
									</Col>

									<Col xs="auto">
										<span className="ps-2">
											<CartIcon />
										</span>
									</Col>
								</div>
							</FadeInOut>

							<DesktopNavigation slimNav={slimNav} />
						</Col>
					</div>
				</ConditionalWrapper>
			)}
			{/* <hr /> */}
			{SubNav && <Row className={` g-0 `}>{SubNav.Desktop({ megaNavName, userDropdownOpen })}</Row>}

			<style jsx>{`
				.animate-all {
					transition: all 0.15s ease;
				}
				.myDashboard {
					font-size: 13px;
					line-height: 28px;
				}
			`}</style>
		</header>
	);
}
